/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * * MaterialRounded Info (`teal-300`) overlaid with MaterialRounded Route (`white`) on a `grey-400` background.
 */

export const ICON_INFO_WITH_ROUTE = (
  <svg fill="none" height="176" viewBox="0 0 176 176" width="176" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 88C0 39.3989 39.3989 0 88 0C136.601 0 176 39.3989 176 88V149.153C176 163.98 163.98 176 149.153 176H88C39.3989 176 0 136.601 0 88Z"
      fill="#F5F5F5"
    />
    <rect fill="white" height="100" rx="50" width="100" x="38" y="34" />
    <path
      clipRule="evenodd"
      d="M88 34C60.4 34 38 56.4 38 84C38 111.6 60.4 134 88 134C115.6 134 138 111.6 138 84C138 56.4 115.6 34 88 34ZM88 109C85.25 109 83 106.75 83 104V84C83 81.25 85.25 79 88 79C90.75 79 93 81.25 93 84V104C93 106.75 90.75 109 88 109ZM83 69H93V59H83V69Z"
      fill="#057E91"
      fillRule="evenodd"
    />
    <rect fill="#BABABA" height="50" rx="25" width="50" x="108" y="106" />
    <rect height="50" rx="25" stroke="#F5F5F5" strokeWidth="4" width="50" x="108" y="106" />
    <path
      d="M140 134.18V126C140 123.79 138.21 122 136 122C133.79 122 132 123.79 132 126V136C132 137.1 131.1 138 130 138C128.9 138 128 137.1 128 136V127.82C129.16 127.4 130 126.3 130 125C130 123.34 128.66 122 127 122C125.34 122 124 123.34 124 125C124 126.3 124.84 127.4 126 127.82V136C126 138.21 127.79 140 130 140C132.21 140 134 138.21 134 136V126C134 124.9 134.9 124 136 124C137.1 124 138 124.9 138 126V134.18C136.84 134.59 136 135.69 136 137C136 138.66 137.34 140 139 140C140.66 140 142 138.66 142 137C142 135.7 141.16 134.6 140 134.18Z"
      fill="white"
    />
  </svg>
);
